/**
 * Whether a path shows the reasoner, where the reVeal icon toggles the thread
 * panel instead of navigating. An open thread counts: matching `/reVeal` alone
 * made the icon navigate away from a thread instead of reopening its panel.
 */
export const isReasonerPath = (pathname: string): boolean =>
  pathname === '/' || pathname === '/reVeal' || pathname.startsWith('/reVeal/');
